// export const API_BASE_URL = process.env.NODE_ENV == "development" ? process.env.REACT_APP_BACKEND : "https://localhost:8990/api";
export const API_BASE_URL = process.env.REACT_APP_BACKEND;

//All API URLS
export const MASTER_FILE_UPLOAD_API = "/masterfiles_upload";
export const FILE_DOWNLOAD_API = "/download";
export const BASE_FILE_UPLOAD_API = "/upload";

export const DISPLAY_SUMMARY_COST_DASHBOARD =
  "/baselinecost/summaryCostForDashBoard";
export const NUTRITION_DISPLAY_SUMMARY_COST_DASHBOARD =
  "/baselinecost/nutrition/summaryCostForDashBoard";

// Medium Home care summary cost for dashboard
export const MEDIUM_DISPLAY_SUMMARY_COST_DASHBOARD =
  "/baselinecost/mediumterm/homecare/summaryCostForDashBoard";
export const MEDIUM_NUTRITION_DISPLAY_SUMMARY_COST_DASHBOARD =
  "/baselinecost/mediumterm/nutrition/summaryCostForDashBoard";

//Time period API's
// Medium Home gettimeperiod api
export const MEDIUM_HOME_DISPLAY_MONTH_NAMES_API =
  "/scenario/mediumterm/homecare/gettimeperiod";
// Medium nutrition gettimeperiod api
export const MEDIUM_NUTRITION_DISPLAY_MONTH_NAMES_API =
  "/scenario/mediumterm/nutrition/gettimeperiod";
export const DISPLAY_MONTH_NAMES_API = "/scenario/gettimeperiod";
export const NUTRITION_DISPLAY_MONTH_NAMES_API =
  "/scenario/nutrition/gettimeperiod";
export const GET_LONGTERM_TIMEPERIOD_API = "/longterm/scenario/gettimeperiod";

export const DISPLAY_FOLDER_LIST_API = "/folder/getall";
export const DISPLAY_FOLDER_LIST_BY_USECASE_API = "/folder/getallbyusecase";
export const GET_USER_MODAL_PREFERENCES_API =
  "/api/UserSelectedSetting/getsettingsbyuserid";
export const ADD_USER_SETTINGS_API = "/api/UserSelectedSetting/addsetting";
export const SAVE_USER_MODAL_PREFERENCES_API =
  "/api/UserSelectedSetting/updatesetting";
export const DISPLAY_FOLDER_LIST_BY_USECASE_AND_USERID_API =
  "/folder/getallbyusecaseanduserid";
export const SELECTED_DISPLAY_FOLDER_API = "/folder/getById";
export const CREATE_NEW_FOLDER_API = "/folder/add";
export const DISPLAY_SCENARIO_FILTER_API = "/scenario/getById";
export const GET_SENARIO_NUMBER_API = "/scenario/getmaxid";
export const GET_DUPLICATE_SCENARIO_API = "/storage/clone";

//Azure Maps URL
export const GET_AZURE_MAP_DATA = "/baselinecost/azuremaps";
export const NUTRITION_GET_AZURE_MAP_DATA = "/baselinecost/nutrition/azuremaps";

// Medium HomeCare Azuremaps
export const MEDIUM_GET_AZURE_MAP_DATA =
  "/baselinecost/mediumterm/homecare/azuremaps";

// Medium Nutrition Azuremaps

export const MEDIUM_NUTRITION_GET_AZURE_MAP_DATA =
  "/baselinecost/mediumterm/nutrition/azuremaps";

export const GET_SAS_URI_API_OLD = "/ADLS/SASUri";
export const GET_SAS_URI_API = "/ADLSSAS/SASUri";
// CGO Upload now
export const GET_CGO_SAS_URI_API = "/ADLSSAS/cog/SASUri";
export const GET_LONG_TERM_SAS_URI_API = "/ADLSSAS/Nakshatra/SASUri";

// export const CREATE_NEW_FOLDER_API = "/ADLS/CreateFolder";
//export const CREATE_NEW_SCENARIO_API = "/ADLS/CreateScenario";
export const CREATE_NEW_SCENARIO_API = "/scenario/add";

export const VIEW_MANUFACTURING_MASTER_TABLE_API =
  "/manufacturemaster/master/getall";
export const DOWNLOAD_MANUFACTURING_MASTER_TABLE_API =
  "/manufacturemaster/master/getalldownload";
export const DISPLAY_MANUFACTURING_FILTERS_API =
  "/manufacturemaster/master/getfilterall";
export const EDIT_MANUFACTURING_MASTER_TABLE_API =
  "/manufacturemaster/master/updateById";

export const BULK_EDIT_MANUFACTURING_MASTER_TABLE_API =
  "/manufacturemaster/master/updateByIds";

export const VIEW_LANDED_COST_TABLE_API = "/LandedCost/getall";
export const DOWNLOAD_LANDED_COST_TABLE_API = "/LandedCost/getalldownload";
export const DISPLAY_LANDED_COST_API = "/LandedCost/getfilterall";
export const EDIT_LANDED_COST_TABLE_API = "/LandedCost/updateById";
export const NEW_EDIT_LANDED_COST_TABLE_API = "/LandedCost/updateByIds";

export const VIEW_MANUFACTURING_MASTER_1_TABLE_API =
  "/manufacturemaster/master/getall";
export const DOWNLOAD_MANUFACTURING_MASTER_1_TABLE_API =
  "/manufacturemaster/master/getalldownload";
export const DISPLAY_MANUFACTURING_MASTER_1_TABLE_API =
  "/manufacturemaster/master/getfilterall";
export const EDIT_MANUFACTURING_MASTER_1_TABLE_API =
  "/manufacturemaster/master/updateById";

// medium Home Landed Cost
export const MEDIUM_HOME_LANDEDCOST_GETALL =
  "/mediumterm/homecare/landedcost/getall";
export const BUILK_EDIT_MEDIUM_HOME_LANDEDCOST_UPDATEBYIDS =
  "/mediumterm/homecare/landedcost/updateByIds";
export const MEDIUM_HOME_LANDEDCOST_UPDATEBYID =
  "/mediumterm/homecare/landedcost/updateById";
export const MEDIUM_HOME_LANDEDCOST_GETALLDOWNLOAD =
  "/mediumterm/homecare/landedcost/getalldownload";

// medium Home Manufacturing
export const MEDIUM_HOME_MANUFACTURE_GETALL =
  "/mediumterm/homecare/manufacturemaster/master/getall";
export const BUILKEDITD_CH_MANUFACTURE_UPDATEBYIDS =
  "/mediumterm/homecare/manufacturemaster/master/updateByIds";
export const MEDIUM_HOME_MANUFACTURE_UPDATEBYID =
  "/mediumterm/homecare/manufacturemaster/master/updateById";
export const MEDIUM_HOME_MANUFACTURE_GETALLDOWNLOAD =
  "/mediumterm/homecare/manufacturemaster/master/getalldownload";

// medium Home OEECPT
export const MEDIUM_HOME_OEE_CPT_GETALL = "/mediumterm/homecare/oeecpt/getall";
export const BUILK_EDIT_MEDIUM_EDIT_OPE_CPT_UPDATEBYIDS =
  "/mediumterm/homecare/oeecpt/updateByIds";
export const MEDIUM_HOME_OEE_CPT_UPDATEBYID =
  "/mediumterm/homecare/oeecpt/updateById";
export const MEDIUM_HOME_OEE_CPT_GETALLDOWNLOAD =
  "/mediumterm/homecare/oeecpt/getalldownload";

// medium Home SHIFT&CHANGEOVER
export const MEDIUM_HOME_SHIFTCHANGEOVER_GETALL =
  "/mediumterm/homecare/shiftchangeover/getall";
export const BUILK_EDIT_MEDIUM_HOME_SHIFTCHANGEOVER_UPDATEBYIDS =
  "/mediumterm/homecare/shiftchangeover/updateByIds";
export const MEDIUM_HOME_SHIFTCHANGEOVER_UPDATEBYID =
  "/mediumterm/homecare/shiftchangeover/updateById";
export const MEDIUM_HOME_SHIFTCHANGEOVER_GETALLDOWNLOAD =
  "/mediumterm/homecare/shiftchangeover/getalldownload";
export const NEW_BULK_EDIT_HOME_SHIFTCHANGEOVER_UPDATEBYID_API =
  "/shiftchangeover/updateByIds";

// Medium nutrition manufacturing master
export const MEDIUM_VIEW_NUT_MANUFACTURING_MASTER_1_TABLE_API =
  "/mediumterm/nutrition/manufacturemaster/master/getall";
export const MEDIUM_DOWNLOAD_NUT_MANUFACTURING_MASTER_1_TABLE_API =
  "/mediumterm/nutrition/manufacturemaster/master/getalldownload";
export const MEDIUM_EDIT_NUT_MANUFACTURING_MASTER_1_TABLE_API =
  "/mediumterm/nutrition/manufacturemaster/master/updateById";
export const BULK_EDIT_NUT_MANUFACTURING_MASTER_API =
  "/nutrition/manufacturemaster/master/updateByIds";
export const NEW_BULK_EDIT_NUT_MEDIUM_MANUFACTURING_MASTER_API =
  "/mediumterm/nutrition/manufacturemaster/master/updateByIds";

// medium Nutrition SHIFT&CHANGEOVER
// export const MEDIUM_NUTRITION_SHIFTCHANGEOVER_GETALL = "/mediumterm/nutrition/shiftchangeover/getall";
// export const MEDIUM_NUTRITION_SHIFTCHANGEOVER_UPDATEBYID = "/mediumterm/nutrition/shiftchangeover/updateById";
// export const MEDIUM_NUTRITION_SHIFTCHANGEOVER_GETALLDOWNLOAD = "/mediumterm/nutrition/shiftchangeover/getalldownload";

// nutrition manufacturing master
export const DISPLAY_MANUFACTURING_MASTER_2_TABLE_API =
  "/nutrition/manufacturemaster/master/getall";
export const DOWNLOAD_NUT_MANUFACTURING_MASTER_2_TABLE_API =
  "/nutrition/manufacturemaster/master/getalldownload";
export const EDIT_NUT_MANUFACTURING_MASTER_1_TABLE_API =
  "/nutrition/manufacturemaster/master/updateById";

// nutrition Packaging master
export const VIEW_NUT_PACKAGING_MASTER_TABLE_API =
  "/nutrition/packagingmaster/getall";
export const DOWNLOAD_NUT_PACKAGING_MASTER_TABLE_API =
  "/nutrition/packagingmaster/getalldownload";
export const EDIT_NUT_PACKAGING_MASTER_TABLE_API =
  "/nutrition/packagingmaster/updateById";
export const NEW_EDIT_NUT_PACKAGING_MASTER_TABLE_API =
  "/nutrition/packagingmaster/updateByIds";

export const VIEW_MANUFACTURING_MASTER_2_TABLE_API = "/shiftchangeover/getall";
export const DOWNLOAD_MANUFACTURING_MASTER_2_TABLE_API =
  "/shiftchangeover/getalldownload";
export const EDIT_MANUFACTURING_MASTER_2_TABLE_API =
  "/shiftchangeover/updateById";

// Medium nutrition Packaging master
export const MEDIUM_VIEW_NUT_PACKAGING_MASTER_TABLE_API =
  "/mediumterm/nutrition/packagingmaster/getall";
export const MEDIUM_DOWNLOAD_NUT_PACKAGING_MASTER_TABLE_API =
  "/mediumterm/nutrition/packagingmaster/getalldownload";
export const MEDIUM_EDIT_NUT_PACKAGING_MASTER_TABLE_API =
  "/mediumterm/nutrition/packagingmaster/updateById";
export const NEW_BUILK_EDIT_MEDIUM_NUT_PACKAGING_MASTER_TABLE_API =
  "/mediumterm/nutrition/packagingmaster/updateByIds";

// nutrition shiftchangeover
export const VIEW_NUT_SHIFTCHANGEOVER_MASTER_2_TABLE_API =
  "/nutrition/shiftchangeover/getall";
export const DOWNLOAD_NUT_SHIFTCHANGEOVER_MASTER_2_TABLE_API =
  "/nutrition/shiftchangeover/getalldownload";
export const EDIT_NUT_SHIFTCHANGEOVER_MASTER_2_TABLE_API =
  "/nutrition/shiftchangeover/updateById";
export const NEW_EDIT_NUT_SHIFTCHANGEOVER_API =
  "/nutrition/shiftchangeover/updateByIds";

// Medium nutrition shiftchangeover
export const MEDIUM_VIEW_NUT_MANUFACTURING_MASTER_2_TABLE_API =
  "/mediumterm/nutrition/shiftchangeover/getall";
export const MEDIUM_DOWNLOAD_NUT_MANUFACTURING_MASTER_2_TABLE_API =
  "/mediumterm/nutrition/shiftchangeover/getalldownload";
export const MEDIUM_EDIT_NUT_MANUFACTURING_MASTER_2_TABLE_API =
  "/mediumterm/nutrition/shiftchangeover/updateById";
export const NEW_BUILK_MEDIUM_EDIT_NUT_SHIFTCHANGEOVER_TABLE_API =
  "/mediumterm/nutrition/shiftchangeover/updateByIds";

export const VIEW_SOURCING_TABLE_API = "/sourcingdata/getall";
export const DOWNLOAD_SOURCING_TABLE_API = "/sourcingdata/getalldownload";
export const DISPLAY_SOURCING_FILTERS_API = "/sourcingdata/getfilterall";
export const EDIT_SOURCING_TABLE_API = "/sourcingdata/updateById";

export const VIEW_OEE_CPT_TABLE_API = "/OEECPT/getall";
export const DOWNLOAD_OEE_CPT_TABLE_API = "/OEECPT/getalldownload";
export const DISPLAY_OEE_CPT_FILTERS_API = "/OEECPT/getfilterall";
export const EDIT_OEE_CPT_TABLE_API = "/OEECPT/updateById";
export const NEW_EDIT_OEE_CPT_TABLE_API = "/OEECPT/updateByIds";
//nutrition packaging OEE and CPT

export const NUTRITION_VIEW_OEE_CPT_TABLE_API =
  "/nutrition/packagingoeeandcpt/getall";
export const NUTRITION_DOWNLOAD_OEE_CPT_TABLE_API =
  "/nutrition/packagingoeeandcpt/getalldownload";
export const NUTRITION_EDIT_OEE_CPT_TABLE_API =
  "/nutrition/packagingoeeandcpt/updateById";
export const NEW_BULK_EDIT_NUTRITION_OEE_CPT_TABLE_API =
  "/nutrition/packagingoeeandcpt/updateByIds";

// Medium nutrition packaging OEE and CPT

export const MEDIUM_NUTRITION_VIEW_OEE_CPT_TABLE_API =
  "/mediumterm/nutrition/packagingoeeandcpt/getall";
export const MEDIUM_NUTRITION_DOWNLOAD_OEE_CPT_TABLE_API =
  "/mediumterm/nutrition/packagingoeeandcpt/getalldownload";
export const MEDIUM_NUTRITION_EDIT_OEE_CPT_TABLE_API =
  "/mediumterm/nutrition/packagingoeeandcpt/updateById";
export const NEW_BUILK_MEDIUM_NUTRITION_EDIT_OEE_CPT_TABLE_API =
  "/mediumterm/nutrition/packagingoeeandcpt/updateByIds";

//nutrition manufacturing OPE and CPT

export const NUTRITION_VIEW_OPE_CPT_TABLE_API =
  "/nutrition/manufacturingopeandcpt/getall";
export const NUTRITION_DOWNLOAD_OPE_CPT_TABLE_API =
  "/nutrition/manufacturingopeandcpt/getalldownload";
export const NUTRITION_EDIT_OPE_CPT_TABLE_API =
  "/nutrition/manufacturingopeandcpt/updateById";
export const NEW_NUTRITION_EDIT_OPE_CPT_API =
  "/nutrition/manufacturingopeandcpt/updateByIds";

// Medium nutrition manufacturing OPE and CPT

export const MEDIUM_NUTRITION_VIEW_OPE_CPT_TABLE_API =
  "/mediumterm/nutrition/manufacturingopeandcpt/getall";
export const MEDIUM_NUTRITION_DOWNLOAD_OPE_CPT_TABLE_API =
  "/mediumterm/nutrition/manufacturingopeandcpt/getalldownload";
export const MEDIUM_NUTRITION_EDIT_OPE_CPT_TABLE_API =
  "/mediumterm/nutrition/manufacturingopeandcpt/updateById";
export const NEW_BUILK_EDIT_MEDIUM_NUTRITION_EDIT_OPE_CPT_TABLE_API =
  "/mediumterm/nutrition/manufacturingopeandcpt/updateByIds";

export const VIEW_PRODUCT_TABLE_API = "/productdata/getall";
export const DOWNLOAD_PRODUCT_TABLE_API = "/productdata/getalldownload";
export const DISPLAY_PRODUCT_TABLE_API = "/productdata/getfilterall";
export const EDIT_PRODUCT_TABLE_API = "/productdata/updateById";

export const DOWNLOAD_GUROBI_API = "/api/GurobiData/gurobidata/getalldownload";
export const NUTRITION_DOWNLOAD_GUROBI_API =
  "/api/GurobiData/gurobidata/nutrition/getalldownload";

// Rerun short term Home care

export const SHORT_TERM_HOMECARE_API = "/rerun/shortterm/homecare";

// Medium Home gurobi  Download

export const MEDIUM_DOWNLOAD_GUROBI_API =
  "/api/GurobiData/gurobidata/mediumterm/homecare/getalldownload";

// Medium Nutrition gurobi  Download

export const NUTRITION_MEDIUM_DOWNLOAD_GUROBI_API =
  "/api/GurobiData/gurobidata/mediumterm/nutrition/getalldownload";

export const DISPLAY_CHART_BASELINE_COST_API =
  "/baselinecost/overallCostByScenarioIds";
export const DISPLAY_CHART_COST_PER_TON_API =
  "/baselinecost/costPerTonByScenarioIds";
export const DISPLAY_CHART_DISTANCE_PER_TON_API =
  "/baselinecost/overalldistancepertonIds";
export const DISPLAY_CHART_DISTANCE_PER_TON_BY_TIME_PERIOD_API =
  "/baselinecost/distancesplitbytime";
export const DISPLAY_CHART_COST_PER_TON_BY_TIME_PERIOD_API =
  "/baselinecost/costpertonsplitbytime";
export const DISPLAY_CHART_OVER_All_COST_BY_TIME_PERIOD_API =
  "/baselinecost/costcomparisionsplitbytime";
export const DISPLAY_CHART_BASELINE_CO2_API =
  "/baselinecost/corbanfootprintIds";
export const DISPLAY_CHART_OVER_All_CO2_BY_TIME_PERIOD_API =
  "/baselinecost/corbanfootprintsplitbytime";

// medium Home Comapre charts apis

export const MEDIUM_DISPLAY_CHART_BASELINE_COST_API =
  "/baselinecost/mediumterm/homecare/overallCostByScenarioIds";
export const MEDIUM_DISPLAY_CHART_COST_PER_TON_API =
  "/baselinecost/mediumterm/homecare/costPerTonByScenarioIds";
export const MEDIUM_DISPLAY_CHART_DISTANCE_PER_TON_API =
  "/baselinecost/mediumterm/homecare/overalldistancepertonIds";
export const MEDIUM_DISPLAY_CHART_DISTANCE_PER_TON_BY_TIME_PERIOD_API =
  "/baselinecost/mediumterm/homecare/distancesplitbytime";
export const MEDIUM_DISPLAY_CHART_COST_PER_TON_BY_TIME_PERIOD_API =
  "/baselinecost/mediumterm/homecare/costpertonsplitbytime";
export const MEDIUM_DISPLAY_CHART_OVER_All_COST_BY_TIME_PERIOD_API =
  "/baselinecost/mediumterm/homecare/costcomparisionsplitbytime";
export const MEDIUM_DISPLAY_CHART_BASELINE_CO2_API =
  "/baselinecost/mediumterm/homecare/corbanfootprintIds";
export const MEDIUM_DISPLAY_CHART_OVER_All_CO2_BY_TIME_PERIOD_API =
  "/baselinecost/mediumterm/homecare/corbanfootprintsplitbytime";

export const NUTRITION_DISPLAY_CHART_BASELINE_COST_API =
  "/baselinecost/nutrition/overallCostByScenarioIds";
export const NUTRITION_DISPLAY_CHART_COST_PER_TON_API =
  "/baselinecost/nutrition/costPerTonByScenarioIds";
export const NUTRITION_DISPLAY_CHART_DISTANCE_PER_TON_API =
  "/baselinecost/nutrition/overalldistancepertonIds";
export const NUTRITION_DISPLAY_CHART_DISTANCE_PER_TON_BY_TIME_PERIOD_API =
  "/baselinecost/nutrition/distancesplitbytime";
export const NUTRITION_DISPLAY_CHART_COST_PER_TON_BY_TIME_PERIOD_API =
  "/baselinecost/nutrition/costpertonsplitbytime";
export const NUTRITION_DISPLAY_CHART_OVER_All_COST_BY_TIME_PERIOD_API =
  "/baselinecost/nutrition/costcomparisionsplitbytime";
export const NUTRITION_DISPLAY_CHART_BASELINE_CO2_API =
  "/baselinecost/nutrition/corbanfootprintIds";
export const NUTRITION_DISPLAY_CHART_OVER_All_CO2_BY_TIME_PERIOD_API =
  "/baselinecost/nutrition/corbanfootprintsplitbytime";

// medium Nutrition Comapre charts apis

export const MEDIUM_NUTRITION_DISPLAY_CHART_BASELINE_COST_API =
  "/baselinecost/mediumterm/nutrition/overallCostByScenarioIds";
export const MEDIUM_NUTRITION_DISPLAY_CHART_COST_PER_TON_API =
  "/baselinecost/mediumterm/nutrition/costPerTonByScenarioIds";
export const MEDIUM_NUTRITION_DISPLAY_CHART_DISTANCE_PER_TON_API =
  "/baselinecost/mediumterm/nutrition/overalldistancepertonIds";
export const MEDIUM_NUTRITION_DISPLAY_CHART_DISTANCE_PER_TON_BY_TIME_PERIOD_API =
  "/baselinecost/mediumterm/nutrition/distancesplitbytime";
export const MEDIUM_NUTRITION_DISPLAY_CHART_COST_PER_TON_BY_TIME_PERIOD_API =
  "/baselinecost/mediumterm/nutrition/costpertonsplitbytime";
export const MEDIUM_NUTRITION_DISPLAY_CHART_OVER_All_COST_BY_TIME_PERIOD_API =
  "/baselinecost/mediumterm/nutrition/costcomparisionsplitbytime";
export const MEDIUM_NUTRITION_DISPLAY_CHART_BASELINE_CO2_API =
  "/baselinecost/mediumterm/nutrition/corbanfootprintIds";
export const MEDIUM_NUTRITION_DISPLAY_CHART_OVER_All_CO2_BY_TIME_PERIOD_API =
  "/baselinecost/mediumterm/nutrition/corbanfootprintsplitbytime";

//Menu Items
export const MENU_ITEMS = "/baselinecost/menuitems";

export const MASTER_FILES_UPLOAD_FOLDER = "masterfiles";
export const UPLOAD_DETAILS_API = "/excelupload/uploaddetails";
export const USECASE_DETAILS_API = "/lookup/getusecase";
export const CATEGORY_DETAILS_API = "/lookup/getallcategory";
export const USERBY_EMAIL = "/user/getuserdetailsbyemailid";

export const DOWNLOAD_TEMPLATE_API = "/storage/download";
export const DOWNLOAD_DC_TEMPLATE_API =
  "/storage/template/dynamicconstraint/download";
export const UPLOAD_DC_API = "/longterm/dynamicconstrains/uploadmoduledetails";
export const DOWNLOAD_TEMPLATE_API_MEDIUM = "/storage/template/download";
export const DOWNLOAD_RERUN_ST_HC_TEMPLATE_API =
  "/rerun/shortterm/homecaredownload";
export const DOWNLOAD_RERUN_ST_NT_TEMPLATE_API =
  "/rerun/shortterm/nutritiondownload";
export const DOWNLOAD_RERUN_MT_HC_TEMPLATE_API =
  "/rerun/mediumterm/homecaredownload";
export const DOWNLOAD_RERUN_MT_NT_TEMPLATE_API =
  "/rerun/mediumterm/nutritiondownload";
export const DOWNLOAD_TEMPLATE_ALL_API = "/storage/alldownload";
export const DOWNLOAD_COG_TEMPLATE_API = "/storage/cogtemplate/download";
export const DOWNLOAD_COG_RERUN_TEMPLATE_API = "/rerun/cog/rerundownload";
export const DOWNLOAD_LT_TEMPLATE_API = "/storage/nakshatratemplate/download";
export const DOWNLOAD_LT_TEMPLATE =
  "/storage/template/nakshatratemplate/download";
export const DOWNLOAD_LT_RERUN_TEMPLATE = "/rerun/longterm/rerundownload";

// CGO Template Download

export const DOWNLOAD_CGO_TEMPLATE_API = "/storage/CGOtemplate/download?type=2";

// Progress Bar Api
export const PROGRESS_BAR_DETAILS_API = "/excelupload/getuploaddetails";
export const RERUN_PROGRESS_BAR_DETAILS_API =
  "/excelupload/getrerunuploaddetails";
export const RERUN_COG_PROGRESS_BAR_DETAILS_API =
  "/excelupload/cog/getcogrerunuploaddetails";

// edit rerun api

export const RERUN_EDIT_HOMECARE_DETAILS_API =
  "/rerun/shortterm/homecare/importmasterfiles";
export const RERUN_EDIT_NUTRITION_DETAILS_API =
  "/rerun/shortterm/nutrition/importmasterfiles";

// export const RERUN_HOMECARE_DETAILS_API = "/rerun/shortterm/homecare";
// export const RERUN_NUTRITION_DETAILS_API = "/rerun/shortterm/nutrition";
// export const RERUN_MEDIUM_HOMECARE_DETAILS_API = "/rerun/mediumterm/homecare";
// export const RERUN_MEDIUM_NUTRITION_DETAILS_API = "/rerun/mediumterm/nutrition";
// export const RERUN_COG_DETAILS_API = "/rerun/cog";
// export const RERUN_LONGTERM_API = "/rerun/longterm";

export const RERUN_HOMECARE_DETAILS_API = "/rerun/shortterm/scenario";
export const RERUN_NUTRITION_DETAILS_API = "/rerun/shortterm/scenario";
export const RERUN_MEDIUM_HOMECARE_DETAILS_API = "/rerun/mediumterm/scenario";
export const RERUN_MEDIUM_NUTRITION_DETAILS_API = "/rerun/mediumterm/scenario";
export const RERUN_COG_DETAILS_API = "/rerun/cog/scenario";
export const RERUN_LONGTERM_API = "/rerun/longterm/scenario";

//flows

export const HOME_FLOW_DROPDOWN_FILTER_API = "/flows/shortterm/getflowoutputs";

export const HOMECARE_GET_TABLE_API =
  "/api/Gurobidata/gurobidata/shortterm/homecare/";

export const NUTRITION_GET_TABLE_API =
  "/api/Gurobidata/gurobidata/shortterm/nutrition/";

// Medium Term Flows

export const MEDIUM_HOMECARE_GET_TABLE_API =
  "/api/Gurobidata/gurobidata/mediumterm/homecare/";

export const MEDIUM_NUTRITION_GET_TABLE_API =
  "/api/Gurobidata/gurobidata/mediumterm/nutrition/";

//cog APIs

export const CGO_FOLDER_GET_API = "/cog/folder/getfolderdetails";
export const CGO_SCENARIO_GET_API = "/cog/scenario/getById";
export const CGO_DEMAND_GET_API = "/cog/getcogdemanddataall";
export const CGO_EXISTINGPLANT_GET_API = "/cog/getcogexistingplantsdataall";
export const CGO_DEMAND_DOWNLOAD_API = "/cog/getcogdemanddatadownload";
export const CGO_EXISTINGPLANT_DOWNLOAD_API =
  "/cog/getcogexistingplantsdatadownload";
export const CGO_AZUREMAPS_GET_API = "/cog/azuremaps";
export const CGO_GUROBI_DOWNLOAD_API = "/cog/gurobidata/getalldownload";
export const CGO_FLOW_API = "/cog/flows/getcogvolumeflowoutput";
export const CGO_FLOW_ADD_API = "/cog/addfolderscenariodetails";
export const CGO_Location_EDIT_API = "/cog/updatepotentiallocation";

export const CGO_DEMAND_UPDATE_API = "/cog/updatedemandbyIds";

export const CGO_EXISTINGPLANT_BULK_UPDATE_API =
  "/cog/updateexisgingplantsByIds";
export const CGO_FLOW_ADD_SCENARIO_API = "/cog/addscenario";
export const CGO_SUMMARY_COST_API = "/cog/summaryCostForDashBoard";
export const CGO_FLOW_OUTPUT_API = "/cog/flows/getcogvolumeflowoutput";
export const CGO_FLOW_OUTPUT2_API = "/cog/flows/getcogvolumeflowplantoutput";
export const CGO_FLOW_OUTPUT_API_DOWNLOAD =
  "/cog/flows/getcogvolumeflowoutputdownload";
export const CGO_FLOW_OUTPUT2_API_DOWNLOAD =
  "/cog/flows/getcogvolumeflowplantoutputdownload";

//
export const CGO_POTENTIAL_DATA_DOWNLOAD =
  "/cog/getcogpotentiallocationdatadownloadblob";

// Long Term Apis
export const LONG_CTREATE_GETALLFOLDERS_API =
  "/longterm/folder/getcreatefolderdetails";

export const LONG_GETALLFOLDERS_API = "/longterm/folder/getfolderdetails";
export const LONG_GETALLSCENARIOS_API = "/longterm/scenario/getById";
export const LONG_GETALLTIMEPERIODS_API = "/longterm/scenario/gettimeperiod";
export const LONG_AZUREMAPS_GET_API = "/baselinecost/longterm/azuremaps";
export const LONG_FACILITY_UPDATE_DATA_API =
  "/longterm/updatenakshatrafacilitymasterbyids";
export const LONG_CASCADE_UPDATE_DATA_API =
  "/longterm/updatenakshatracascademasterbyids";
export const LONG_PROCUREMENT_UPDATE_DATA_API =
  "/longterm/updatenakshatrarmpmmiprocurementbyids";
export const LONG_RMPM_PROCUREMENT_UPDATE_DATA_API =
  "/longterm/updatenakshatra";

export const LONG_DYNAMIC_CONSTRAINS_API =
  "/longterm/dynamicconstrains/getconstrainnamedetails";
export const LONG_DYNAMIC_CONSTRAINS_CRITERIA_API =
  "/longterm/dynamicconstrains/getcriteria1details";
export const LONG_DYNAMIC_CONSTRAINS_GETALL_API =
  "/longterm/dynamicconstrains/getdcmoduledetails";
export const LONG_DYNAMIC_CONSTRAINS_GETALL_CR1WITHTYPE_API =
  "/longterm/dynamicconstrains/getcriteria2detailsbyc1";
export const LONG_DYNAMIC_CONSTRAINS_DELETE_API =
  "/longterm/dynamicconstrains/deletescenariomoduledetailbyid";
export const LONG_DYNAMIC_CONSTRAINS_UPDATE_API =
  "/longterm/dynamicconstrains/updatescenariomoduledetailbyid";
export const LONG_DYNAMIC_CONSTRAINS_UPDATE_BY_ID_API =
  "/longterm/dynamicconstrains/editscenariodcbyid";

export const LONG_DYNAMIC_CONSTRAINS_SAVE_API =
  "/longterm/dynamicconstrains/savemoduledetails";

export const LONG_UPDATE_BULK_EDIT_RMLANDEDCOST_API =
  "/longterm/updatenakshatrarmlandedcostbyids";
export const LONG_UPDATE_BULK_EDIT_RMLANDEDCOST_API_MODULE4 =
  "/longterm/updatenakshatrarmlandedcostmodule4byids";
export const LONG_UPDATE_BULK_EDIT_PMMILANDEDCOST_API =
  "/longterm/updatenakshatrapmmilandedcostbyids";

// Long term FG Bom
export const LONG_GETALL_FGBOM_Module3 =
  "/longterm/getnakshatrafgbommodule3dataall";
export const LONG_Download_FGBOM_Module3 =
  "/longterm/getnakshatrafgbommodule3datadownload";

export const LONG_GETALL_FGBOM = "/longterm/getnakshatrafgbomdataall";

export const LONG_UPDATE_BULK_EDIT_FGB_API =
  "/longterm/updatenakshatrafgbombyids";
export const LONG_UPDATE_BULK_EDIT_FGB_API_Module3 =
  "/longterm/updatenakshatrafgbommodule3byids";

// Long term SFG Bom
export const LONG_GETALL_SFGBOM = "/longterm/getnakshatrasfgbomdataall";

export const LONG_UPDATE_BULK_EDIT_SFGB_API =
  "/longterm/updatenakshatrasfgbombyids";

// Long Term Left menu APIs

export const LONG_FACILITY_MASTER_GET_API =
  "/longterm/getnakshatrafacilitymasterdataall";
export const LONG_CASCADE_MASTER_GET_API =
  "/longterm/getnakshatracascademasterdataall";
export const LONG_RMPM_PROCUREMENT_GET_API =
  "/longterm/getnakshatrarmpmprocurement";
export const LONG_PROCUREMENT_GET_API =
  "/longterm/getnakshatrarmpmmiprocurementdataall";
export const LONG_RMPM_TRANSPORTATION_GET_API =
  "/longterm/getnakshatrarmpmtransport";
export const LONG_RM_TRANSPORTATION_GET_API =
  "/longterm/getnakshatrarmpmmitransportationdataall";
export const LONG_PROCESSING_PLANT_GET_API =
  "/longterm/getnakshatraprocessingplantdataall";
export const LONG_PACKAGING_PLANT_GET_API =
  "/longterm/getnakshatrapackagingplantdataall";
export const LONG_PRIMARY_TRANSPORTATION_GET_API =
  "/longterm/getnakshatraprimarytransportationdataall";
export const LONG_CFG_TRANSPORTATION_GET_API =
  "/longterm/getnakshatrasfgtransportationdataall";
export const LONG_BULK_EDITCFG_TRANSPORTATION_API =
  "/longterm/updatesfgtransportationByIds";
export const LONG_BULK_EDIT_PACK_PLANT_API =
  "/longterm/updatepackagingplantByIds";
export const LONG_DEMAND_GET_API = "/longterm/getnakshatrademanddataall";

// long term left menu Download Apis
export const LONG_DEMAND_DOWNLOAD_API =
  "/longterm/getnakshatrademanddatadownload";

export const LONG_FACILITY_MASTER_DOWNLOAD_API =
  "/longterm/getnakshatrafacilitymasterdatadownload";
export const LONG_CASCADE_MASTER_DOWNLOAD_API =
  "/longterm/getnakshatracascademasterdatadownload";
export const LONG_PROCUREMENT_DOWNLOAD_API =
  "/longterm/getnakshatrarmpmmiprocurementdatadownload";
export const LONG_RMPM_PROCUREMENT_DOWNLOAD_API =
  "/longterm/getnakshatrarmpmprocurement";
export const LONG_RMPM_TRANSPORTATION_DOWNLOAD_API =
  "/longterm/getnakshatrarmpmtransport";
export const LONG_RM_TRANSPORTATION_DOWNLOAD_API =
  "/longterm/getnakshatrarmpmmitransportationdatadownload";
export const LONG_PROCESSING_PLANT_DOWNLOAD_API =
  "/longterm/getnakshatraprocessingplantdatadownload";
export const LONG_PACKAGING_PLANT_DOWNLOAD_API =
  "/longterm/getnakshatrapackagingplantdatadownload";
export const LONG_PRIMARY_TRANSPORTATION_DOWNLOAD_API =
  "/longterm/getnakshatraprimarytransportationdatadownload";
export const LONG_CFG_TRANSPORTATION_DOWNLOAD_API =
  "/longterm/getnakshatrasfgtransportationdatadownload";
export const LONG_BULK_EDIT_PROCESSING_PLANT_DOWNLOAD_API =
  "/longterm/updateprocessingplantByIds";
export const LONG_BULK_EDIT_DEMAND_DOWNLOAD_API =
  "/longterm/updatenakshatrademandbyids";

export const LONG__FGBOM_DOWNLOAD_API =
  "/longterm/getnakshatrafgbomdatadownload";
export const LONG__SFGBOM_DOWNLOAD_API =
  "/longterm/getnakshatrasfgbomdatadownload";
// Long Term Flows Api

export const LONG_FLOW_FACILITY_MASTER_GET_API =
  "/longterm/flow/getfacilitymasteroutput";
export const LONG_FLOW_CASCADE_GET_API =
  "/longterm/flow/getcascademasteroutput";
export const LONG_FLOW_RMLANDEDCOST_GET_API =
  "/longterm/flow/getrmlandedcostoutput";
export const LONG_FLOW_RMLANDEDCOST_GET_API_MODULE4 =
  "/longterm/flow/getrmlandedcostmodule4output";
export const LONG_FLOW_PMMILANDEDCOST_GET_API =
  "/longterm/flow/getpmmilandedcostoutput";
export const LONG_FLOW_PROCUREMENT_GET_API =
  "/longterm/flow/getrmpmmiprocurementoutput";
export const LONG_FLOW_RMPM_PROCUREMENT_GET_API =
  "/longterm/flow/getrmpmprocurementoutput";
export const LONG_FLOW_RMPM_PROCUREMENT_GET_API_MODULE5 =
  "/longterm/flow/getrmpmrmpmprocurementmodule5output";
export const LONG_FLOW_RM_TRANSPORTATION_GET_API_MODULE5 =
  "/longterm/flow/getrmpmrmpmtransportmodule5output";

export const LONG_FLOW_RM_TRANSPORTATION_GET_API =
  "/longterm/flow/getrmpmmitransportationoutput";
export const LONG_FLOW_RMPM_TRANSPORTATION_GET_API =
  "/longterm/flow/getrmpmtransporttoutput";
export const LONG_FLOW_PROCESSING_PLANT_GET_API =
  "/longterm/flow/getprocessingplantoutput";
export const LONG_FLOW_SFG_TRANSPORTATION_GET_API =
  "/longterm/flow/getsfgtransportationoutput";
export const LONG_FLOW_PACKAGING_PLANT_GET_API =
  "/longterm/flow/getpackagingplantoutput";
export const LONG_FLOW_PRIMARY_TRANSPORTATION_GET_API =
  "/longterm/flow/getprimarytransportationoutput";
export const LONG_FLOW_DEMAND_OUTPUT_GET_API = "/longterm/flow/getdemandoutput";

export const LONG_FLOW_FACILITY_MASTER_DOWNLOAD_API =
  "/longterm/flow/getfacilitymasteroutputdownload";
export const LONG_FLOW_CASCADE_DOWNLOAD_API =
  "/longterm/flow/getcascademasteroutputdownload";
export const LONG_FLOW_RMLANDEDCOST_DOWNLOAD_API =
  "/longterm/flow/getrmlandedcostdownload";
export const LONG_FLOW_RMLANDEDCOST_DOWNLOAD_API_MODULE4 =
  "/longterm/flow/getrmlandedcostmodule4download";
export const LONG_FLOW_PMMILANDEDCOST_DOWNLOAD_API =
  "/longterm/flow/getpmmilandedcostdownload";
export const LONG_FLOW_PROCUREMENT_DOWNLOAD_API =
  "/longterm/flow/getrmpmprocurementdownload";
export const LONG_FLOW_PROCUREMENT_DOWNLOAD_API_MODULE5 =
  "/longterm/flow/getrmpmrmpmprocurementmodule5download";
export const LONG_FLOW_TRANSPORTATION_DOWNLOAD_API_MODULE5 =
  "/longterm/flow/getrmpmrmpmtransportmodule5download";

export const LONG_FLOW_RM_TRANSPORTATION_DOWNLOAD_API =
  "/longterm/flow/getrmpmtransportdownload";
export const LONG_FLOW_PROCESSING_PLANT_DOWNLOAD_API =
  "/longterm/flow/getprocessingplantoutputdownload";
export const LONG_FLOW_SFG_TRANSPORTATION_DOWNLOAD_API =
  "/longterm/flow/getsfgtransportationoutputdownload";
export const LONG_FLOW_PACKAGING_PLANT_DOWNLOAD_API =
  "/longterm/flow/getpackagingplantoutputdownload";
export const LONG_FLOW_PRIMARY_TRANSPORTATION_DOWNLOAD_API =
  "/longterm/flow/getprimarytransportationoutputdownload";
export const LONG_FLOW_DEMAND_OUTPUT_DOWNLOAD_API =
  "/longterm/flow/getdemandoutputdownload";

export const LONG_ADD_FOLDERSCENARIO_GET_API =
  "/longterm/addfolderscenariodetails";
export const LONG_ADD_SCENARIO_GET_API = "/longterm/addscenariodetails";
export const UPDATE_PROCESSING_PLANTS_BY_IDS =
  "/longterm/updatepackagingplantByIds";
export const UPDATE_BULK_PRI_TRA_BY_IDS =
  "/longterm/updateprimarytransportationByIds";

// Uploads the additional files when long term file is uploaded
export const LONG_QUESTIONARE_DOWNLOAD_API =
  "/longterm/getquestionnairedownloadblob";

//gurabi data long term download api
export const LONG_SUMMARY_COST_PER_DASHBOARD_API =
  "/baselinecost/longterm/summaryCostForDashBoard";
export const LONG_TERM_ALL_DOWNLOAD = "/longterm/gurobidata/getalldownload";
export const LONG_TERM_ALL_DOWNLOAD2 =
  "/longterm/gurobidata/getalldownloadmodule2";
export const LONG_TERM_ALL_DOWNLOAD3 =
  "/longterm/gurobidata/getalldownloadmodule3";
export const LONG_TERM_ALL_DOWNLOAD4 =
  "/longterm/gurobidata/getalldownloadmodule4";
export const LONG_TERM_ALL_DOWNLOAD5 =
  "/longterm/gurobidata/getalldownloadmodule5";
export const LONG_TERM_ALL_DOWNLOAD6 =
  "/longterm/gurobidata/getalldownloadmodule6";

export const LT_DISPLAY_CHART_BASELINE_COST_API =
  "/baselinecost/longterm/overallCostByScenarioIds";
export const LT_DISPLAY_SCENARIO_FILTER_API = "/longterm/scenario/getById";

export const LT_DISPLAY_CHART_COST_PER_TON_API =
  "/baselinecost/longterm/costPerTonByScenarioIds";
export const LT_DISPLAY_CHART_BASELINE_CO2_API =
  "/baselinecost/longterm/corbanfootprintIds";
export const LT_DISPLAY_CHART_DISTANCE_PER_TON_API =
  "/baselinecost/longterm/overalldistancepertonIds";
export const LONG_EXCEL_FILE_UPLOAD_API =
  "/excelupload/longterm/getuploaddetails";

export const UPLOAD_SHORTTERM_FILE_API = "/ADLSSAS/uploadshorttermfiles";
export const UPLOAD_MEDIUMTERM_FILE_API = "/ADLSSAS/uploadmediumtermfiles";
export const UPLOAD_LONGTERM_FILE_API = "/ADLSSAS/uploadlongtermfiles";
export const UPLOAD_COG_FILE_API = "/ADLSSAS/uploadcogfiles";

export const UPLOAD_SHORTTERM_SINGLE_FILE_API = "/uploadstfile";
export const UPLOAD_MEDIUMTERM_SINGLE_FILE_API = "/uploadmtfile";
export const UPLOAD_LONGTERM_SINGLE_FILE_API = "/uploadltfile";
export const UPDATE_FOLDER_STATUS = "/folder/updatefolderstatus";
export const UPLOAD_COG_SINGLE_FILE_API = "/uploadcogfile";
// get upload details COG

export const COG_EXCEL_FILE_UPLOAD_API = "/excelupload/cog/getuploaddetails";
export const GET_DUPLICATE_COG_SCENARIO_API = "/storage/cogclone";
export const GET_DUPLICATE_LT_SCENARIO_API = "/storage/longtermclone";
export const LONG_UPDATE_BULK_EDIT_API =
  "/longterm/updatenakshatrarmpmmitransportationbyids";
export const LONG_UPDATE_BULK_RMPM_EDIT_API = "/longterm/updatenakshatra";

// LOng term module 2 apis

export const LT_RMLANDEDCOST_MODULE2 =
  "/longterm/getnakshatrarmlandedcostdataall";
export const LT_RMLANDEDCOST_MODULE4 =
  "/longterm/getnakshatrarmlandedcostmodule4dataall";

export const LT_PMMILANDEDCOST_MODULE2 =
  "/longterm/getnakshatrapmmilandedcostdataall";

export const LT_RMLANDEDCOST_MODULE2_DOWNLOAD =
  "/longterm/getnakshatrarmlandedcostdatadownload";
export const LT_RMLANDEDCOST_MODULE4_DOWNLOAD =
  "/longterm/getnakshatrarmlandedcostmodule4datadownload";

export const LT_PMMILANDEDCOST_MODULE2_DOWNLOAD =
  "/longterm/getnakshatrapmmilandedcostdatadownload";

// long term time period
export const GET_LONGTERM_RERUN_UPLOAD_API =
  "/excelupload/longterm/getlongtermrerunuploaddetails";

export const LONG_TERM_BASIC_VALIDATION_API = "/basicvalidation";
export const LONG_TERM_QUESTIONNAIRE_API = "/getquestionnaire";
export const LONG_TERM_AZURE_PATH_API = "/getazurepath";
